import React from "react";
import "./ErrorPage.css"
import { Link } from 'react-router-dom'

const ErrorPage: React.FC = () => {

    return (
        <div id="wrapper" className="errorMsgDiv" >
            <div className="error-page">
                <div className="top-div">
                   <img src="https://cdn.dribbble.com/users/722246/screenshots/3066818/404-page.gif" alt=""/>
                </div>
                <div className="middle-div">
                    {/* <h3>OOPS! Page Not Found</h3> */}
                    <h3>OOPS! The page you are looking for does not exist.</h3>
                </div>
                <div className="bottom-div">
                    <Link className="go-to-home-btn" to="/home">Go to Home</Link>
                </div>
            </div>
        </div>
    );
}
export default ErrorPage;